var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "subscription-payment-dialog" }, [
    _c("header", { staticClass: "dialog-heading" }, [
      _c(
        "span",
        { staticClass: "dialog-icon", attrs: { "aria-hidden": "true" } },
        [_c("portal-icon", { attrs: { name: "receipt-text", size: 20 } })],
        1
      ),
      _c("h2", [_vm._v(_vm._s(_vm.$t("subscriptions.heading")))]),
      _c(
        "button",
        {
          staticClass: "dialog-close",
          attrs: { type: "button", "aria-label": _vm.$t("global.close") },
          on: {
            click: function($event) {
              return _vm.$emit("result")
            }
          }
        },
        [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
        1
      )
    ]),
    _c(
      "div",
      {
        staticClass:
          "subscription-payment-table-shell portal-compact-list-shell"
      },
      [
        _c("v-data-table", {
          staticClass: "portal-compact-table subscription-payment-table",
          attrs: {
            headers: _vm.headers,
            items: _vm.payments,
            "mobile-breakpoint": 0,
            "disable-pagination": "",
            "hide-default-footer": ""
          },
          scopedSlots: _vm._u([
            {
              key: "item.amount",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$formatters.dollars(
                          item.amount,
                          true,
                          true,
                          item.currency
                        )
                      )
                    )
                  ])
                ]
              }
            },
            {
              key: "item.paid",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "portal-status-pill",
                    {
                      attrs: {
                        background: item.paid
                          ? "var(--v-success_10-base)"
                          : "var(--v-gray_20-base)",
                        color: item.paid
                          ? "var(--v-success-base)"
                          : "var(--portal-muted)"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$formatters.yesNoFromBoolean(item.paid)) +
                          " "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _c("footer", { staticClass: "dialog-footer" }, [
      _c(
        "button",
        {
          staticClass: "done-action",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("result")
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("global.done")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }